/**
 * Theme JS building
 */
import '../../../vaasa/assets/scripts/modernizr';
import 'modaal';
import 'slick-carousel';
import 'hypher/dist/jquery.hypher.js';
import 'hyphenation.en-gb';
import 'hyphenation.fi';
import 'hyphenation.sv';
import 'jquery-ui-dist/jquery-ui.js';
import 'wicg-inert/dist/inert.min.js';

import './fonts';
import Theme from '../../../vaasa/assets/scripts/theme';

// Export the theme controller for global usage.
window.Theme = Theme;

// Import and load the JS for the Area Choice modal
import AreaChoiceModal from './area-choice-modal';

window.AreaChoiceModal = AreaChoiceModal.docReady();

// Import and load the JS for the Map Embed component
import MapEmbed from './map-embed';

window.MapEmbed = MapEmbed.docReady();

// Require main style file here for concatenation.
import '../styles/main.scss';



// WEBPACK FOOTER //
// ./assets/scripts/main.js